export const DB_NAME = 'form-db';
export const STORE_NAME = 'formData';
export const DB_VERSION = 1;
export const CV_BUILDER_FORM_KEY = 'cv-builder';
